<!-- Capture-prep popup "הכנה לצילום" -->
<mat-dialog-content cdkTrapFocus class="prep-content">

  <h2 class="pp-title">{{ "cameraInstructions.title" | translate }}</h2>
  <p class="pp-sub"><b>4</b> {{ "cameraInstructions.subtitle" | translate }}</p>

  <!-- magenta instruction banner -->
  <div class="banner">
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path d="M4 14V8a4 4 0 0 1 4-4h6M44 14V8a4 4 0 0 0-4-4h-6M4 34v6a4 4 0 0 0 4 4h6M44 34v6a4 4 0 0 1-4 4h-6"
            stroke="#fff" stroke-width="3" stroke-linecap="round"/>
      <circle cx="24" cy="20" r="6.5" stroke="#fff" stroke-width="3"/>
      <path d="M14.5 36c1.4-5 5-8 9.5-8s8.1 3 9.5 8" stroke="#fff" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <p>{{ "cameraInstructions.banner" | translate }}</p>
  </div>

  <!-- steps + photo -->
  <div class="grid">
    <div class="steps">
      <div class="step"><span class="step-num">1</span><span class="step-txt">{{ "cameraInstructions.step1" | translate }}</span></div>
      <div class="step"><span class="step-num">2</span><span class="step-txt">{{ "cameraInstructions.step2" | translate }}</span></div>
      <div class="step"><span class="step-num">3</span><span class="step-txt">{{ "cameraInstructions.step3" | translate }}</span></div>
      <div class="step"><span class="step-num">4</span><span class="step-txt">{{ "cameraInstructions.step4" | translate }}</span></div>
    </div>

    <div class="photo">
      <img src="assets/images/capture-prep-face.webp" [alt]="'a11y.cameraInstructionsAlt' | translate"
           (error)="onImgError($event)">
      <div class="ph" [hidden]="!imgFailed">
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <circle cx="24" cy="18" r="9" stroke="currentColor" stroke-width="2.5"/>
          <path d="M9 42c2-9 8-13 15-13s13 4 15 13" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="prep-actions">
  <button mat-raised-button class="cta" cdkFocusInitial (click)="submitInstructions()">
    {{ "cameraInstructions.gotIt" | translate }}
  </button>
</mat-dialog-actions>
